import React, {useEffect, useRef} from 'react';
import CajitaBuscador from './componentesHTML/CajitaBuscador'
import SelectBuscador from './componentesHTML/SelectBuscador'
import HipervinculoCole from './componentesHTML/HipervinculoCole'
import Resultados from './componentesHTML/Resultados'
import CambioIdioma from "./componentesHTML/scripts/CambioIdioma";
import {StoreProvider} from '../stores/Global'
import PruebaReact from './componentesHTML/PruebaReact'

const PrincipalContainer = () => {
    const encabezado_buscar = useRef(null);
    let var_ingles = "es";
    if (window.location.href.indexOf("en.") > -1) {
        var_ingles = "en"
    }
    const mystyle = {
        background: "#fff",
        border: "#ddd 1px solid"
    };
    const scrollTopAnimated = () => {
        $('html, body').animate({ scrollTop: 0 }, 'slow');
    }
    useEffect(() => {
        if (encabezado_buscar !== null){
            CambioIdioma.valida(var_ingles, encabezado_buscar);
        }
    },[]);
   
    return (
        <StoreProvider>
            <div className="col-xs-12" id="colContenido">
                <div id="containersearch" className="row con_desf_inf" style={mystyle}>
                    <div className="col-xs-12" style={{paddingBottom:"10px"}}>
                    <h2 className="h3 text-primary" id="encabezado_buscar" ref={encabezado_buscar}>
                        <span className="d-none">Presentación</span>{" "}
                        Buscador
                    </h2>
                    </div>
                    <div className="col-xs-12" id="marcoPrincipal">
                        <CajitaBuscador />
                        <SelectBuscador/> 
                        {/* <PruebaReact /> */}
                        <HipervinculoCole /> 
                        <Resultados/> 
                        {
                            scrollTopAnimated()
                        }
                    </div>
                </div>
            </div>
        </StoreProvider> 
    )
    
}
export default PrincipalContainer;